<ion-app [ngClass]="{ web: shared.web }">
    <ion-router-outlet [ngClass]="{ blur: system.blur }"></ion-router-outlet>
</ion-app>
